<template>
	<div class="flex h-screen items-center justify-center">
		<div class="flex w-full flex-col items-center justify-center">
			<BaseInput v-model="token" label="Token" placeholder="Enter your JWT token" class="w-1/2" />
			<Button class="mt-04 w-64" @click="storeToken">Enter</Button>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { BaseInput, Button } from '@bluebrick/saas-ui'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/features/user/useUserStore'
import { PATH } from '@/routes'

const { setUserToken, initUser } = useUserStore()

const token = ref<string>('')
const router = useRouter()

const storeToken = async () => {
	setUserToken(token.value)

	await initUser()

	router.push({
		path: PATH.PLANNER
	})
}
</script>
